<template>
  <tr style="cursor: pointer;" :style="{ height }" @click="onClickHandler">
    <!-- ID -->
    <td v-if="fieldsToDisplay.includes('id')" class="text-center align-middle id">
      {{ id }}
    </td>
    <!-- /ID -->
    <!-- Type -->
    <td v-if="fieldsToDisplay.includes('type')" class="text-center align-middle">
      {{ showTextByValue('type', type) }}
    </td>
    <!-- /Type -->

    <!-- Title -->
    <td v-if="fieldsToDisplay.includes('title')" class="align-middle">
      <span class="bold ellipsis">{{ title }}</span>
    </td>
    <!-- /Title -->

    <!-- Creator -->
    <td v-if="fieldsToDisplay.includes('creator')" class="text-center align-middle">

      <user-profile :id="creatorId" :name="creatorName" :post="creatorProfileImagePath" />
    </td>

    <td v-if="fieldsToDisplay.includes('creationDate')" class="text-center align-middle">
      {{ creationDate | formatDate }}
    </td>
  </tr>
</template>
<script>
import UserProfile from '../../board/UserProfile.vue';


export default {
  name: 'RequirementItem',
  components: {
    UserProfile,
  },
  props: {
    fieldsToDisplay: {
      type: Array,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: '80px'
    },
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
    },
    creatorId: {
      type: String,
      required: false,
    },
    creatorName: {
      type: String,
      required: false,
    },
    creatorProfileImagePath: {
      type: String,
      required: false,
    },
    creationDate: {
      type: String,
      required: false,
    },
    updatedDate: {
      type: String,
      required: false,
    }
  },
  methods: {
    onClickHandler() {
      this.$emit('onClick', this.id);
    },
    showTextByValue(fieldName, value) {
      const options = this.$store.getters[`requirement/${fieldName}Options`];
      let text = value;
      if (options) {
        const findOption = options.find(option => option.value === value);
        text = findOption ? findOption.text : value;
      }

      return text;
    },
  },
  filters: {
    formatDate(dateStr) {
      return dateStr.replace(/^(\d{4}-\d{2}-\d{2}).*/, "$1"); // "2023-03-11"
    }
  }
}

</script>
<style scoped>
tr td {
  height: 100%;
  padding: 0.344rem;
}

.id {
  font-size: 0.9rem;
}

.bold {
  font-weight: bold;
}

.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
}
</style>